import $ from 'jquery';

$('.burger').click(() => {
    if ($('.mobile-nav').hasClass('mobile-nav--opened')) {
        $('.header-middle').removeClass('header-middle--visible');
        $('.header-bottom').removeClass('header-bottom--visible');
        $('.mobile-nav').removeClass('mobile-nav--opened');
        $('.header-submenu').css('display', 'none');
    } else {
        $('.header-middle').addClass('header-middle--visible');
        $('.header-bottom').addClass('header-bottom--visible');
        $('.mobile-nav').addClass('mobile-nav--opened');
    }
});

$('.header-menu__arrow').click(function () {
    if ($(window).width() < 1024) {
        $(this).siblings('.header-submenu').slideToggle(200);
    }
});
